const ViewAllFilter = (props) => {
  return (
    <div className="empty-fillter-container">
      <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1668757837/intel/Filters/filternotfound_illustration_xm8bnm.svg" />
      <p className="text-center mt-4 mb-0">
        No matching <strong>{props.label ?? props.keyword}</strong> found for{" "}
      </p>
      <p className="text-center mt-1">the combination of search and applied filters</p>
    </div>
  );
};

export default ViewAllFilter;
